module.exports = __webpack_public_path__ + "img/logo.b4d80067.svg";